import { render } from "./ItemNews.vue?vue&type=template&id=468957c8"
import script from "./ItemNews.vue?vue&type=script&lang=js"
export * from "./ItemNews.vue?vue&type=script&lang=js"

import "./ItemNews.vue?vue&type=style&index=0&id=468957c8&lang=css"

import exportComponent from "/home/nimens/projects/cafe-portos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__